import en_keyset from "./en_keyset.json"
import fr_keyset from "./fr_keyset.json"

export const keysets = {
    "en": en_keyset,
    "fr": fr_keyset
};


// WEBPACK FOOTER //
// ./node_modules/@adactive/arc-keyboard/src/keysets/keysets.js